<script>
import HongKongFields from '@phoenix/mixins/components/myAccount/addresses/HongKongFields';

export default {
  mixins: [HongKongFields],
};
</script>

<template>
  <div class="w-full">
    <form-group :attrs="fields.state">
      <select-field v-model="fields.state.value" />
    </form-group>
  </div>

  <div class="w-full mt-base">
    <form-group :attrs="fields.address10">
      <select-field v-model="fields.address10.value" :disabled="fields.address10.options.length === 0" />
    </form-group>
  </div>
</template>
